import React from "react";
import useStyles from './styles';
import Status from  "./Status";
import Sim from "./Sim";
import {prettyDateTime} from '../../../../utils/date';

const Message = ({message}) => {

    const classes = useStyles();
    const isReceiver = !!message?.receiver;

    return (
      <>
        {!isReceiver && (
          <div className={classes.messageSender}>
            <div className={isReceiver ? classes.containerLeft : classes.containerRight} id={`message-container-${message?.id}`} data-cy={`message-container-${message?.id}`}>
              <div className={classes.header} id={`message-header-${message?.id}`} data-cy={`message-header-${message?.id}`}>
                <div className={classes.subHeader} id={`message-container-${message?.id}`} data-cy={`message-container-${message?.id}`}>
                  <Sim
                    sim1={message?.showSim1Icon}
                    sim2={message?.showSim2Icon}
                    statusComponent1={<Status type={message?.statusWhatsApp1} id={`message-sender-status-sim1-${message?.id}`} data-cy={`message-sender-status-sim1-${message?.id}`}/>}
                    statusComponent2={<Status type={message?.statusWhatsApp2} id={`message-sender-status-sim2-${message?.id}`} data-cy={`message-sender-status-sim2-${message?.id}`}/>}
                    id={`message-sim2-${message?.id}`}
                    data-cy={`message-sim2-${message?.id}`}
                  />
                </div>
              </div>
              <div
                id={`message-container-id`}
                data-cy={`message-container-data-cy`}
              >
                <div
                  id={`message-strong-container-id`}
                  data-cy={`message-strong-container-data-cy`}
                  className={classes.messageHeader}
                >
                  <strong id={`message-strong-${message?.id}`} data-cy={`message-strong-${message?.id}`}>
                    De:
                  </strong>
                  <span style={{marginLeft: '5px'}} id={`message-sender-span-${message?.id}`} data-cy={`message-sender-span-${message?.id}`}>
                    {`${message?.sender}`} - {`${prettyDateTime(message?.time)}`}
                  </span>
                </div>
                <div
                  id={`message-body-container-id`}
                  data-cy={`message-body-container-data-cy`}
                >
                  <div className={classes.bodySender} id={`message-body-${message?.id}`} data-cy={`message-body-${message?.id}`}>
                      {message?.body}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {isReceiver && (
          <div className={classes.messageReceiver}>
            <div className={isReceiver ? classes.containerLeft : classes.containerRight} id={`message-container-${message?.id}`} data-cy={`message-container-${message?.id}`}>
              <div className={classes.header} id={`message-header-${message?.id}`} data-cy={`message-header-${message?.id}`}>
                <div className={classes.subHeader} id={`message-subheader1-${message?.id}`} data-cy={`message-subheader1-${message?.id}`}>
                  <Sim
                    sim1={message?.showSim1Icon}
                    sim2={message?.showSim2Icon}
                    statusComponent1={<Status type={message?.statusWhatsApp1} id={`message-receiver-status-sim1`} data-cy={`message-receiver-status-sim1`}/>}
                    statusComponent2={<Status type={message?.statusWhatsApp2} id={`message-receiver-status-sim2`} data-cy={`message-receiver-status-sim2`}/>}
                    id={`message-sim1-${message?.id}`}
                    data-cy={`message-sim1-${message?.id}`}
                  />
                </div>
              </div>
              <div
                id={`message-container-id`}
                data-cy={`message-container-data-cy`}
              >
                <div
                  id={`message-strong-container-id`}
                  data-cy={`message-strong-container-data-cy`}
                  className={classes.messageHeader}
                >
                  <strong id={`message-strong-${message?.id}`} data-cy={`message-strong-${message?.id}`}>
                    Para:
                  </strong>
                  <span style={{marginLeft: '5px'}} id={`message-receiver-span-${message?.id}`} data-cy={`message-receiver-span-${message?.id}`}>
                    {`${message?.receiver}`} - {`${prettyDateTime(message?.time)}`}
                  </span>
                </div>
                <div
                  id={`message-body-container-id`}
                  data-cy={`message-body-container-data-cy`}
                >
                  <div className={classes.bodyReceiver} id={`message-body-${message?.id}`} data-cy={`message-body-${message?.id}`}>
                      {message?.body}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
}

export default Message;
